import { SupplierInvoiceStatusEnum } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class ChangeSupplierInvoiceStatusDto {
  @Expose()
  id: string;

  @Expose()
  status: SupplierInvoiceStatusEnum;
}
